import { useEffect,useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { visualizerActions, uiActions } from '../../store';


import styles from './Visualizer.module.css';

export default function Visualizer() {
    const urlParams = useParams();
    const dispatch = useDispatch();

    const vizLoading = useSelector((state) => state.ui.vizLoading);
    //used to only show popup once per session
    const marketingModalStatusCalled = useRef(false);
    const isMarketingPopupClosed = sessionStorage.getItem('marketingPopupClosed');

    useEffect(() => {
        const marketingModalEndDate = new Date('2024-09-30');
        const currentDate = new Date();
        
        document.getElementById("chamViz").addEventListener('ready', function (result) {
            document.getElementById("chamViz").useMouseovers = false;

            let surfaceData = structuredClone(result.value);
            let saveData = document.getElementById('chamViz').getSaveData();
            

            dispatch(visualizerActions.setSpecifier(saveData.specifier));
            dispatch(visualizerActions.setSurfaceList(surfaceData));
            dispatch(uiActions.setVizLoading(false));
            
            dispatch(visualizerActions.setSelString(saveData.sel));
            
            if (currentDate <= marketingModalEndDate && !isMarketingPopupClosed && !marketingModalStatusCalled.current) {
                dispatch(uiActions.setMarketingModalStatus(true));
                // Ref to track if the action has been called
                marketingModalStatusCalled.current = true;
            }
            
        });

        document.getElementById("chamViz").addEventListener('surface_apply_done', function (result) {
            let saveData = document.getElementById('chamViz').getSaveData();
            dispatch(visualizerActions.setSelString(saveData.sel));
            dispatch(uiActions.setVizLoading(false))
        });

        document.getElementById('chamViz').load(urlParams.specifier, urlParams.selString);
    }, [urlParams.specifier, urlParams.selString, dispatch])

    return (
        <div className={`${styles.vizContainer} ${vizLoading?styles.loading:''}`}>
            <div className={styles.loadingScreen}>Loading...</div>
            <cham-viz id="chamViz" spec="" width="1024" height="725" active="1"></cham-viz>
        </div>
    );
}